
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterFilter1 as ObiConverterFilter1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-filter-1.js';
 
 
 

 
 export const ObiConverterFilter1 = createComponent({
   react: React,
   tagName: 'obi-converter-filter-1',
   elementClass: ObiConverterFilter1Element,
   events: {
     
   }
  });
 
 